"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const Mention = (props) => {
  const _a = props, { className, size = IconSize.Medium, color = "inherit" } = _a, rest = __objRest(_a, ["className", "size", "color"]);
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    __spreadValues({ width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass }, rest),
    /* @__PURE__ */ React.createElement("path", { d: "M16.457 7.692h-2.16l-.15.67c-.322-.471-1.092-.918-2.11-.918-2.656 0-4.568 2.458-4.568 5.214 0 2.085 1.316 3.7 3.352 3.7.893 0 1.936-.522 2.383-1.341.497.844 1.515 1.34 2.681 1.34 2.508 0 4.941-1.912 4.941-5.983C20.826 6.178 17.45 3 12.51 3 6.823 3 3 7.246 3 12.46 3 18.442 7.668 21 12.534 21c2.26 0 4.32-.546 5.561-1.167v-1.787c-1.564.695-3.252 1.191-5.561 1.191-3.377 0-7.548-1.54-7.548-6.778 0-4.543 3.079-7.671 7.523-7.671 3.674 0 6.405 2.085 6.405 5.586 0 2.656-1.092 4.295-2.631 4.295-.77 0-.969-.372-.82-1.241l.994-5.736zm-3.203 5.512c-.397.596-1.018 1.142-1.887 1.142-1.043 0-1.614-.77-1.614-1.812 0-1.59.944-3.104 2.433-3.104.795 0 1.39.447 1.59 1.018l-.522 2.756z" })
  );
};
export default Mention;
